import React from 'react';
import PublicationYear from './PublicationYear.tsx';
import PublicationItem from './PublicationItem.tsx';

interface MobilePublicationProps {
    BulletMainAuthor: string;
    BulletMajorAuthor: string;
    BulletCommon: string;
}

const MobilePublication: React.FC<MobilePublicationProps> = ({
    BulletMainAuthor,
    BulletMajorAuthor,
    BulletCommon,
}) => {
    return (
        <div className='md:w-[95vw] sm:w-[98vw] h-auto pr-2'>
            <PublicationYear year={2026} isMobile isLastYear={false}>
                <PublicationItem
                    bulletStyle={BulletMainAuthor}
                    title="PingPong: A Natural Benchmark for Multi-Turn Code-Switching Dialogues"
                    authors={
                        <>
                            <span className="font-extrabold">M. Rifqi Farhansyah</span>
                            <sup>*</sup>, H. M. Zhafran<sup>*</sup>, F. Adilazuarda, M. I. Mukhtar,
                            S. H. Muhammad, N. Ousidhoum, S. Reddy, P. Kumaraguru, P. Kodali, S. Sitaram,
                            G. I. Winata, A. Purwarianti, A. F. Aji
                        </>
                    }
                    conference="Empirical Methods in Natural Language Processing (EMNLP) - Main Conference"
                    conferenceLink="#"
                    date="October 2026"
                    isMobile={true}
                />
                <PublicationItem
                    bulletStyle={BulletCommon}
                    title="R3: Robust Rubric-Agnostic Reward Models"
                    authors={
                        <>
                            D. Anugraha, Z. Tang, L. J. V. Miranda, H. Zhao, <span className="font-extrabold">M. Rifqi Farhansyah</span>
                            , G. Kuwanto, D. Wijaya, G. I. Winata
                        </>
                    }
                    conference="Transaction on Machine Learning Research (TMLR)"
                    conferenceLink="#"
                    date="Agustus 2026"
                    // link="https://neurips.cc/virtual/2025/loc/san-diego/122408"
                    isMobile={true}
                />
                <PublicationItem
                    bulletStyle={BulletMainAuthor}
                    title="When Indirectness Breaks Understanding: Evaluating LLMs on Euphemism in Low-Resource Languages for Women's Sexual and Reproductive Health"
                    authors="Anonymous Author(s)."
                    conference="Manuscript available upon request. In submission."
                    conferenceLink="#"
                    date=""
                    isMobile={true}
                />
            </PublicationYear>

            <PublicationYear year={2025} isMobile isLastYear={false}>
                <PublicationItem
                    bulletStyle={BulletMainAuthor}
                    title="Do Language Models Understand Honorific Systems in Javanese?"
                    authors={
                        <>
                            <span className="font-extrabold">M. Rifqi Farhansyah</span>
                            <sup>*</sup>, I. Darmawan<sup>*</sup>, A. Kusumawardhana, G. I.
                            Winata, A. F. Aji, D. T. Wijaya
                        </>
                    }
                    conference="Association for Computational Linguistics (ACL) - Main Conference"
                    conferenceLink="https://2025.aclweb.org/"
                    date="May 2025"
                    link="https://arxiv.org/pdf/2502.20864"
                    isMobile={true}
                />
                <PublicationItem
                    bulletStyle={BulletMajorAuthor}
                    title="Crowdsource, Crawl, or Generate? Creating SEA-VL, a Multicultural Vision-Language Dataset for Southeast Asia."
                    authors={
                        <>
                            S.Cahyawijaya<sup>*</sup>, H. Lovenia<sup>*</sup>, J. R. A.
                            Moniz<sup>*</sup>, T. H. Wong<sup>*</sup>,{' '}
                            <span className="font-extrabold">M. Rifqi Farhansyah</span>, +87
                            more authors
                        </>
                    }
                    conference="Association for Computational Linguistics (ACL) - Main Conference"
                    conferenceLink="https://2025.aclweb.org/"
                    date="May 2025"
                    link="https://arxiv.org/pdf/2503.07920"
                    isMobile={true}
                />
            </PublicationYear>

            <PublicationYear year={2024} isMobile isLastYear={false}>
                <PublicationItem
                    bulletStyle={BulletMainAuthor}
                    title="DriveThru: a Document Extraction Platform and Benchmark Datasets for Indonesian Local Language Archives"
                    authors={
                        <>
                            <span className="font-bold">M. Rifqi Farhansyah*</span>, M. Z.
                            Fikri Johari*, A. Amiral, A. Purwarianti, K. A. Yuana,{' '}
                            <span className="text-textRed">D. Tanti Wijaya</span>.
                        </>
                    }
                    conference="Garuda Academic and researCh of Excellence (Garuda ACE) Collaboration Project"
                    conferenceLink="#"
                    date="December 2024"
                    link="https://arxiv.org/abs/2411.09318"
                    isMobile={true}
                />
            </PublicationYear>
        </div>
    );
};

export default MobilePublication;